


import Vue from 'vue';
import Swiper from 'swiper';
import $ from 'jquery';
import 'jquery-match-height';
import ItemsListComponent from '@/components/items/list/items-list.vue';
import {RouteName} from "@/router";
import {Location} from "vue-router";
import i18n, {localizedRoute} from "@/i18n/i18n.config";
import {OfferItem, TranslatedString} from "@/components/model/offer-item";
import {offer} from "@/components/offer/offer.service";
import {archive} from "@/components/archive/archive.service";
import {pageTitle} from "@/components/common/pageTitle";

interface Data {
    isLoading: boolean
    items: OfferItem[]
    isArchiveLoading: boolean
    archiveItems: OfferItem[]
    swiper?: Swiper
    swiperInitialized: boolean
    i18n: typeof i18n
}

export default Vue.extend({
    data: (): Data => ({
        isLoading: false,
        items: [],
        isArchiveLoading: false,
        archiveItems: [],
        swiperInitialized: false,
        i18n
    }),
    created() {
        this.setPageTitle();
        this.isLoading = true;
        offer.loadAll()
            .then(items => this.items = items)
            .finally(() => this.isLoading = false);
        this.isArchiveLoading = true;
        archive.loadHighlight(6)
            .then(items => this.archiveItems = items)
            .finally(() => this.isArchiveLoading = false);
    },
    updated() {
        if (!this.swiperInitialized && this.archiveItems.length) {
            this.swiper = new Swiper('.swiper-container', {
                loop: true,
                spaceBetween: 30,
                roundLengths: true,
                breakpoints: {
                    992: {
                        slidesPerView: 3,
                        allowTouchMove: false
                    }
                },
                breakpointsInverse: true,
                pagination: {
                    el: '.swiper-pagination',
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            });
            $(() => {
                $('.slide').matchHeight();
            });
            this.swiperInitialized = true;
        }
    },
    beforeRouteEnter(to, from, next) {
        pageTitle.setTitle(i18n.locale === 'pl' ? 'Aktualna oferta' : 'Our current offer');
        next();
    },
    watch: {
        'i18n.locale'() {
            this.setPageTitle();
        }
    },
    computed: {
        detailsRouteName(): RouteName {
            return RouteName.offerDetails;
        },
        archiveListRoute(): Location {
            return localizedRoute(RouteName.archiveList);
        }
    },
    methods: {
        nextSlide() {
            if (this.swiper) {
                this.swiper.slideNext();
            }
        },
        prevSlide() {
            if (this.swiper) {
                this.swiper.slidePrev();
            }
        },
        archiveDetailsRouteFor(item: OfferItem): string {
            return '/' + i18n.locale + '/archiwum/' + item.urlFriendlyName + '/' + item.id;
        },
        getLocalizedString(value: TranslatedString): string {
            return i18n.locale === 'pl' ? value.pl : value.en;
        },
        setPageTitle() {
            pageTitle.setTitle(this.$t('offer.title'));
        }
    },
    metaInfo() {
        return {
            link: [
                {vmid: 'canonical', rel: 'canonical', href: location.origin + this.$route.fullPath}
            ]
        }
    },
    components: {
        'items-list': ItemsListComponent
    }
});
